import { render, staticRenderFns } from "./Orm.vue?vue&type=template&id=e0e62986&scoped=true"
import script from "./Orm.vue?vue&type=script&lang=js"
export * from "./Orm.vue?vue&type=script&lang=js"
import style0 from "./Orm.vue?vue&type=style&index=0&id=e0e62986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e62986",
  null
  
)

export default component.exports